import React from 'react';
import { Link } from 'react-router-dom';

/** Title block used by the inner pages (Buy guides, MemeFi, Games). */
const PageHeader = ({ eyebrow, title, highlight, sub, back }) => (
  <div className="pt-5 lg:pt-10">
    {back && (
      <Link to={back.to} className="btn btn-paper btn-sm mb-5">
        <span aria-hidden="true">←</span> {back.label}
      </Link>
    )}
    {eyebrow && <span className="chip mb-3">{eyebrow}</span>}
    <h1 className="text-[36px] font-bold leading-[1.08] tracking-[0.5px] sm:text-[44px] lg:text-[56px]">
      {title} {highlight && <span className="hl">{highlight}</span>}
    </h1>
    {sub && <p className="mt-4 max-w-[640px] text-[17px] font-medium lg:text-lg">{sub}</p>}
  </div>
);

export default PageHeader;
